import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const abAdminRBAC = {
  pageID: '563fff9c7903b212c9fc8e7eb9b8764c',
  elementID: {
    ViewPage: '602434e1f629b7f689e32cac966e695a',
    CreateExperiment: 'f8bdf462b3ad784d10f7e8f78ed675f9',
    EditExperiment: '3dda6a0d63852b240c4c2dd500340949',
    Whitelist: 'a4e7049cb0555c630b2faac1eb4e8327',
    PauseExperiment: 'd8a60a581e00d10642d94e580b03062b',
    ResumeExperiment: 'e16620a99d889024d3c009abe72d472c',
  },
} as const

export const useRBACAbAdminPage = createUseRBAC(abAdminRBAC.elementID)

export type UseRBACAbAdminPageType = ReturnType<typeof useRBACAbAdminPage>
